export const NO_PAN_IN_FIELD = /^((?![\d ]{10,}).)*$/;
export const SPACE_UPPER_LOWER_ALPHA_NUMERIC = /^[ a-zA-Z0-9]*$/;
export const NUMERIC_ONLY = /^[0-9]*$/;
// Mapping to make it clear of intent
export const US_POSTAL_NUMERIC = NUMERIC_ONLY;

export const CA_POSTAL_SPACE_ALPHA_NUMERIC = /^[ A-Z0-9]*$/;

// probably doesn't need the length check
export const NUMERIC_DATE = /^[0-9 /]*$/;

// https://developer.jpmorgan.com/products/merchant_payments/specification
// Can be alphanumeric, but if you add a space or hyphen you must have alphanumeric afterward.
// This has to allow for "abc-" due to requiring a - while typing without a alphanumeric after it
// Can't start with a space or hyphen
export const UPG_POSTAL = /^[a-zA-Z0-9]+([- ]?[a-zA-Z0-9]*)*$/;

// https://developer.jpmorgan.com/api/v0/items/orbital-api/assets/OGW%20JSON%20Developer%20Guide%20Payments%20Request.pdf
// While testing we found space and hyphen are also allowed so the regex it matches UPG
// Original Alpha numeric spec from doc
// export const ORB_POSTAL = /^[a-zA-Z0-9]*$/;
export const ORB_POSTAL = UPG_POSTAL;
